import { useState, useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import MarqueeStrip from "@/components/MarqueeStrip";
import DivineFlowGallery from "@/components/DivineFlowGallery";
import DanceClassSection from "@/components/DanceClassSection";
import SoundHealingSection from "@/components/SoundHealingSection";
import ProductsSection from "@/components/ProductsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import PaymentSuccess from "@/components/PaymentSuccess";

const HomePage = () => {
  const classesRef = useRef(null);
  const soundHealingRef = useRef(null);
  const productsRef = useRef(null);
  const contactRef = useRef(null);

  const scrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F9F6F0]">
      <Navbar
        onClassesClick={() => scrollTo(classesRef)}
        onSoundHealingClick={() => scrollTo(soundHealingRef)}
        onProductsClick={() => scrollTo(productsRef)}
        onContactClick={() => scrollTo(contactRef)}
      />
      <HeroSection
        onBookClick={() => scrollTo(soundHealingRef)}
        onDanceClick={() => scrollTo(classesRef)}
      />
      <MarqueeStrip />
      <div ref={soundHealingRef}>
        <SoundHealingSection />
      </div>
      <div ref={classesRef}>
        <DanceClassSection />
      </div>
      <DivineFlowGallery />
      <div ref={productsRef}>
        <ProductsSection />
      </div>
      <div ref={contactRef}>
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
